// hooks/useTabParam.js
//
// Drop-in replacement for `useState('someDefault')` for any value that
// represents WHICH TAB/VIEW IS SHOWING on an otherwise-single-URL page
// (e.g. Community's channel tabs, the discovery mode toggle, the admin
// queue's Books/Tropes tab). Same [value, setValue] signature as useState,
// so swapping it in is a one-line change — nothing else in the component
// needs to know the value now lives in the URL.
//
// Why a query param and not a path segment: these are secondary selectors
// on a page that already has its own route (e.g. /community, /discover,
// /admin/queue) rather than distinct destinations of their own. Putting
// them in ?tab= still makes them bookmarkable/shareable, keeps them in
// history for Back, and survives refresh — without minting a new path for
// every toggle.
//
// Usage:
//   const [tab, setTab] = useTabParam('tab', 'books');
//   // exactly replaces: const [tab, setTab] = useState('books');

import { useSearchParams } from 'react-router-dom';

export function useTabParam(key, defaultValue) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) || defaultValue;

  function setValue(next) {
    setSearchParams(prev => {
      const p = new URLSearchParams(prev);
      p.set(key, next);
      return p;
    });
  }

  return [value, setValue];
}